export default __webpack_public_path__ + "static/media/github.c066df3c.svg";